import { inject } from 'mobx-react';
import { SideMenuComponent } from './component';
export const SideMenu = inject(({ ui }) => ({
    menu: ui.menu,
    envLabel: ui.environmentLabel,
}))(SideMenuComponent);
//# sourceMappingURL=index.js.map